import { SITE_HG, COUNTRY } from '@/config';

const GATOR_PROTECT_URL_BY_BRAND = {
  br: `${SITE_HG}/gator-protect`,
  cl: `${SITE_HG}/gator-protect`,
  co: `${SITE_HG}/gator-protect`,
  mx: `${SITE_HG}/gator-protect`,
  ar: `${SITE_HG}/gator-protect`,
  pe: `${SITE_HG}/gator-protect`,
  bo: `${SITE_HG}/gator-protect`,
  cr: `${SITE_HG}/gator-protect`,
  do: `${SITE_HG}/gator-protect`,
  ec: `${SITE_HG}/gator-protect`,
  sv: `${SITE_HG}/gator-protect`,
  pa: `${SITE_HG}/gator-protect`,
  py: `${SITE_HG}/gator-protect`,
  uy: `${SITE_HG}/gator-protect`,
};

export const GATOR_PROTECT_URL = GATOR_PROTECT_URL_BY_BRAND[COUNTRY];
